import { render, staticRenderFns } from "./DetailMutasiMasuk.vue?vue&type=template&id=5138f0c6"
import script from "./DetailMutasiMasuk.vue?vue&type=script&lang=js"
export * from "./DetailMutasiMasuk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports